module.exports = __webpack_public_path__ + "static/images/f2c7c36b5cb598dca54b60f4f11da1a8.svg";